import { get } from '@ember/helper';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismViewSwitcher } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import {
  type BeniBreakdownType,
  type Kpi,
  KPI_LONG_TRANSLATIONS,
  KPIS,
} from 'lumen/utils/constants/benchmark-insight/beni-constant-values';

interface HotelBenchmarkInsightButtonGroupChartKpisSignature {
  Args: {
    breakdownType: BeniBreakdownType;
    changeSelectedKpi: (kpi: Kpi) => void;
    dataTestId?: string;
    selectedKpi: Kpi;
  };
}

export default class HotelBenchmarkInsightButtonGroupChartKpis extends Component<HotelBenchmarkInsightButtonGroupChartKpisSignature> {
  @service declare usageAnalytics: Services['usage-analytics'];

  @action
  handleSetActiveButton(kpi: string): void {
    if (kpi === this.args.selectedKpi) {
      return;
    }

    this.args.changeSelectedKpi(kpi as Kpi);

    this.usageAnalytics.track('Primary Chart Axis Changed', {
      eventTrigger: this.args.breakdownType,
      product: 'benchmark-insight',
      type: kpi,
    });
  }

  <template>
    <div data-test-id={{@dataTestId}}>
      <PrismViewSwitcher
        @activeButtonId={{@selectedKpi}}
        @onSetActiveButtonId={{this.handleSetActiveButton}}
        as |ViewSwitcher|
      >
        <ViewSwitcher.button
          @id={{KPIS.OCCUPANCY}}
          @label={{t (get KPI_LONG_TRANSLATIONS KPIS.OCCUPANCY)}}
        />

        <ViewSwitcher.button
          @id={{KPIS.ADR}}
          @label={{t (get KPI_LONG_TRANSLATIONS KPIS.ADR)}}
        />

        <ViewSwitcher.button
          @id={{KPIS.REVPAR}}
          @label={{t (get KPI_LONG_TRANSLATIONS KPIS.REVPAR)}}
        />
      </PrismViewSwitcher>
    </div>
  </template>
}
